'use strict';

export default function buildComparisonAlert (message) {
    let type = 'comparison';

    let $alert = $('.alert-error[data-type="' + type + '"]');
    $alert.remove();

    return [
        `<div class="alert alert-orange clearfix js-alert" data-type="${type}">`,
            `<span class="alert-text js-alert-msg">${message}</span>`,
            `<a href="${translations.alerts[type].link2}" class="alert-link pull-right js-alert-button clear-comparison">${translations.alerts[type].button2}</a>`,
            `<span class="alert-link pull-right">&nbsp;|&nbsp;</span>`,
            `<a href="${translations.alerts[type].link}" class="alert-link pull-right js-alert-button">${translations.alerts[type].button}</a>`,
        `</div>`
    ].join('');
}
